import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { directoryAssetsManager, type IDirectoryAsset } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const DIRECTORY_ASSET_MODULE = 'directoryAsset';

const dataObjectModule = getDataObjectsModule<IDirectoryAsset>(directoryAssetsManager);
const searchModule = getSearchModule<IDirectoryAsset>(directoryAssetsManager);

const directoryAssetModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(DIRECTORY_ASSET_MODULE, directoryAssetModuleInstance);

export { DIRECTORY_ASSET_MODULE };
